import { MetricDetails } from '../../../../api/metrics/types';
import { MetricId } from '../../../../api/types-graphql';
import { LanguageString } from '../../dashboards/types';
import { FactboxFontSizes } from '../../ui-components/data-viz-ui/factboxes/common/types';
import {
  ExternalChartComponentProps,
  KpiComponentSectionConfig,
  KpiSectionValue,
} from '../common/types';

export type KpiFactboxTwoMetricVizExternalProps = ExternalChartComponentProps;

export interface KpiFactboxTwoMetricVizConfig {
  title?: LanguageString;
  subtitle?: LanguageString;
  footer?: LanguageString;
  fontSize?: FactboxFontSizes;
  sections: {
    leftSection: KpiComponentSectionConfig;
    rightSection: KpiComponentSectionConfig;
  };
}
export type KpiFactboxTwoMetricVizDataResponse = {
  firstSectionValue: KpiSectionValue;
  secondSectionValue: KpiSectionValue;
};

export type KpiFactboxTwoMetricVizData = {
  title?: string;
  subtitle?: string;
  footer?: string;
  fontSize?: FactboxFontSizes;
  dataResponse: KpiFactboxTwoMetricVizDataResponse;
  metricDetailsMap: Partial<Record<MetricId, MetricDetails>>;
};

export enum KpiFactboxTwoMetricVizViews {
  FACTBOX = 'factbox',
}
